import React, { useState,useEffect } from 'react';
import Navbar from '../Components/NavBarAirbnbStyle';
import MapShow from '../Components/mapShow';
import Footer from '../Components/footer';
import '../Pages/mapPlaces.css';
import NavbarMobileVersion from '../Components/NavBar/NavBarMobileVersion';

const MapPlaces = () => {
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [selectedSpace, setSelectedSpace] = useState(null);

    const handleSelectPlace = (place) => {
        setSelectedPlace(place);
    };

    const handleSelectSpace = (space) => {
        setSelectedSpace(space);
    };
 const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      // Intentamos leer valor guardado en localStorage
      const saved = localStorage.getItem('darkMode');
      if (saved !== null) {
        const parsed = JSON.parse(saved);
        if (typeof parsed === 'boolean') return parsed; // Solo si es booleano válido
      }
    } catch (error) {
      // Si JSON.parse falla o localStorage no está disponible, ignoramos el error
      console.warn('Error leyendo localStorage darkMode:', error);
    }

    // Detectar modo oscuro sistema solo si está disponible window.matchMedia
    const prefersDark = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;

    // Detectar hora nocturna (7pm a 6am)
    const hour = new Date().getHours();
    const isNight = hour >= 19 || hour < 6;

    // Retorna true o false seguro
    return prefersDark || isNight;
  });

  // Cargar el tema al inicio (localStorage, sistema u hora)
  useEffect(() => {
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme !== null) {
      setIsDarkMode(JSON.parse(savedTheme));
    } else {
      // Detecta modo oscuro sistema
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

      // Detecta modo oscuro por hora (7pm - 6am)
      const hour = new Date().getHours();
      const isNight = hour >= 19 || hour < 6;

      setIsDarkMode(prefersDark || isNight);
    }
  }, []);

  // Guardar la preferencia y aplicar clase al body
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  // Función para cambiar el modo
  const toggleDarkMode = () => setIsDarkMode(!isDarkMode);

    return (
        <>
            <Navbar isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
            <NavbarMobileVersion isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
            <div className="map-places">
            <MapShow onSelectPlace={handleSelectPlace} onSelectSpace={handleSelectSpace} />
            </div>
            <Footer />
        </>
    );
};

export default MapPlaces;
